import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Button, FormikInput, Loader } from "../../../../../components/ui";
import styles from "./style.module.scss";
import jwtInterceptor from "../../../../../api/jwtInterceptor";
import { GET_API_URLS } from "../../../../../utils/constant";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-bootstrap-icons";

const validationSchema = Yup.object().shape({
  start_date: Yup.string().required("Start date is required"),
  end_date: Yup.string().required("End date is required"),
});

const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  // Extract just the YYYY-MM-DD part from the ISO string
  return dateString.split("T")[0];
};

const CoffeeConfiguration = () => {
  const [activeEvent, setActiveEvent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const fetchCoffeeEvents = async () => {
    setIsLoading(true);
    try {
      const response = await jwtInterceptor.get(GET_API_URLS.COFFEE_EVENTS);
      const activeEvent = response.data.find((event) => event.is_active);
      console.log("activeEvent", activeEvent);
      if (activeEvent) {
        setActiveEvent(activeEvent);
      }
    } catch (error) {
      console.error("Error fetching coffee events:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCoffeeEvents();
  }, []);

  const updateEventDates = async (values) => {
    if (!activeEvent?.id) return;

    setLoading(true);
    try {
      await jwtInterceptor.patch(
        `${GET_API_URLS.COFFEE_EVENTS}${activeEvent.id}/`,
        {
          event_start_date: values.start_date,
          event_end_date: values.end_date,
        }
      );
      await fetchCoffeeEvents();
    } catch (error) {
      console.error("Error updating event dates:", error);
    } finally {
      setLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className={styles.configurationForm}>
        <Button
          label={
            <>
              <ArrowLeft /> Back
            </>
          }
          onClick={() => navigate(-1)}
          secondary
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            width: "fit-content",
          }}
        />
        {activeEvent && (
          <Formik
            initialValues={{
              start_date:
                formatDateForInput(activeEvent.event_start_date) || "",
              end_date: formatDateForInput(activeEvent.event_end_date) || "",
            }}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={updateEventDates}
          >
            {({ errors, touched, getFieldProps }) => (
              <Form>
                <div className={styles.formContainer}>
                  <FormikInput
                    type="date"
                    name="start_date"
                    label="Event Start Date"
                    formikProps={getFieldProps("start_date")}
                    formikTouch={touched.start_date}
                    formikErrors={errors.start_date}
                    style={
                      touched.start_date && errors.start_date
                        ? { borderColor: "red" }
                        : null
                    }
                  />

                  <FormikInput
                    type="date"
                    name="end_date"
                    label="Event End Date"
                    formikProps={getFieldProps("end_date")}
                    formikTouch={touched.end_date}
                    formikErrors={errors.end_date}
                    style={
                      touched.end_date && errors.end_date
                        ? { borderColor: "red" }
                        : null
                    }
                  />
                </div>
                <Button
                  type="submit"
                  label={loading ? "Saving..." : "Save Changes"}
                  disabled={loading}
                  primary
                  style={{ maxWidth: "20rem", marginLeft: "auto" }}
                />
              </Form>
            )}
          </Formik>
        )}
      </div>
    </>
  );
};

export default CoffeeConfiguration;
